import { render, staticRenderFns } from "./AddEditCourse.vue?vue&type=template&id=38dbfea0"
import script from "./AddEditCourse.vue?vue&type=script&lang=js"
export * from "./AddEditCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports